import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import CashLedgerLayer from "../../components/Accounts/CashLedgerLayer";

const CashLedgerPage = () => {
  return (
    <MasterLayout>
      <CashLedgerLayer />
    </MasterLayout>
  );
};

export default CashLedgerPage;
